module.exports = __webpack_public_path__ + "static/media/location-pointer.85949146.svg";